import { useState } from "react";
import { Box, Stack, Switch, useTheme } from "@mui/material";
import Text from "../../../_components/Text";
import CustomPaper from "../../../_components/CustomPaper";
import SwitchField from "../../../components/ui/inputs/SwitchField";

const InsuranceLevel = () => {
  const theme = useTheme();

  const [insuranceLevel, setInsuranceLevel] = useState<string>("current");
  const handleChangeInsuranceLevel = (value: string) => setInsuranceLevel(value);

  return (
    <CustomPaper 
			label="Insurance level" 
			labelVariant="regular"
			color={theme.myTheme.colors.gray500}
		>
      <Stack
        paddingTop={1}
        direction="column"
        alignItems={"center"}
        sx={{ width: "100%" }}
        justifyContent={"space-between"}
        spacing={1}
      >
        <Box>
          <Text variant="s" color={theme.myTheme.colors.foreground50}>
            Out-of-Range Insurance through an option minimizes losses if the asset moves out of
            range.
          </Text>
        </Box>
        <SwitchField
					fullWidth
          value={insuranceLevel}
          onChange={handleChangeInsuranceLevel}
          paramList={[
						{value: "current", label: "Current price"},
						{value: "lower", label: "Lower limit"}
					]}
        />
      </Stack>
    </CustomPaper>
  );
};

export default InsuranceLevel;
